import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import Aboutus from "../components/staticContent/Aboutus";
import GeneralTerms from "../components/staticContent/GeneralTerms";
import Kyc from "../components/staticContent/Kyc";
import PrivacyPolicy from "../components/staticContent/PrivacyPolicy";
import RulesRegulation from "../components/staticContent/RulesRegulation";
import ResponsibleGaming from "../components/staticContent/ResponsibleGaming";
import { FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import LoadingPage from "../components/loader/LoadingPage";

function Login() {
  const { loginUser, isLoged, content, slug, setSlug, handleContentToggle } =
    useContext(AuthProvider);

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    reset: reset2,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  const [passwordType, setPasswordType] = useState("password");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const togglePassword = (e) => {
    e.preventDefault();
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  const onSubmit2 = (data) => {
    setLoading(true);
    loginUser(data);
    setLoading(false);
  };

  useEffect(() => {
    if (isLoged === "failed") {
      reset2({ validateCode: "" });
      setLoading(false);
    }
  }, [isLoged]);

  return (
    <>
      {/* Full-screen green gradient background */}
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(180deg, #14805e 0%, #184438 100%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          padding: "40px 20px 140px",
        }}
      >
        {/* Close (X) button - 3D look */}
        <div
          role="button"
          aria-label="Close login"
          tabIndex={0}
          onClick={() => navigate("/")}
          onKeyDown={(e) => e.key === "Enter" && navigate("/")}
          style={{
            position: "fixed",
            top: "16px",
            right: "16px",
            background: "var(--site-header-gradient)",
            borderRadius: "10px",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 100,
            color: "#000",
            userSelect: "none",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
            aria-hidden="true"
          >
            <path d="M6 6L18 18M18 6L6 18" />
          </svg>
        </div>

        {/* Logo */}
        <div style={{ marginBottom: "32px", textAlign: "center" }}>
          <img
            src="/logo.png"
            alt="Logo"
            style={{ width: "200px", height: "auto" }}
            onError={(e) => {
              e.target.src = "/logo.png";
            }}
          />
        </div>

        {/* Form container */}
        <form
          onSubmit={handleSubmit2(onSubmit2)}
          style={{ width: "90vw", maxWidth: "250px" }}
        >
          <style>{`
            .login-credential-input::placeholder {
              color: #808080;
              opacity: 1;
            }
            .login-credential-input {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              box-shadow: none !important;
            }
            .login-credential-input:focus {
              box-shadow: none !important;
              outline: none !important;
            }
            .login-credential-input:-webkit-autofill,
            .login-credential-input:-webkit-autofill:focus {
              -webkit-box-shadow: 0 0 0 1000px #fff inset;
              -webkit-text-fill-color: #000;
              caret-color: #000;
            }
          `}</style>
          {/* Username field */}
          <div style={{ marginBottom: "12px" }}>
            <div
              style={{
                position: "relative",
                height: "40px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                className="login-credential-input"
                type="text"
                autoComplete="off"
                placeholder="Username"
                {...register2("username", {
                  required: "Please enter Username",
                })}
                style={{
                  width: "100%",
                  height: "40px",
                  padding: "8px 40px 8px 12px",
                  borderRadius: "4px",
                  border: errors2.username ? "1px solid #ff4444" : "1px solid #6ab00f",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  outline: "none",
                  boxSizing: "border-box",
                  backgroundColor: "#fff",
                  color: "#000",
                  margin: 0,
                  verticalAlign: "middle",
                  boxShadow: "none",
                  appearance: "none",
                  WebkitAppearance: "none",
                }}
              />
              <FaUser
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#000",
                  fontSize: "16px",
                  pointerEvents: "none",
                }}
              />
            </div>
            {errors2.username && (
              <span style={{ color: "#ff4444", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {errors2.username.message}
              </span>
            )}
          </div>

          {/* Password field */}
          <div style={{ marginBottom: "16px" }}>
            <div
              style={{
                position: "relative",
                height: "40px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                className="login-credential-input"
                type={passwordType}
                autoComplete="off"
                placeholder="Password"
                {...register2("password", {
                  required: "Please enter password",
                })}
                style={{
                  width: "100%",
                  height: "40px",
                  padding: "8px 40px 8px 12px",
                  borderRadius: "4px",
                  border: errors2.password ? "1px solid #ff4444" : "1px solid #6ab00f",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  outline: "none",
                  boxSizing: "border-box",
                  backgroundColor: "#fff",
                  color: "#000",
                  margin: 0,
                  verticalAlign: "middle",
                  boxShadow: "none",
                  appearance: "none",
                  WebkitAppearance: "none",
                }}
              />
              <span
                onClick={togglePassword}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#000",
                  fontSize: "20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {passwordType === "password" ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}
              </span>
            </div>
            {errors2.password && (
              <span style={{ color: "#ff4444", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {errors2.password.message}
              </span>
            )}
          </div>

          {/* Login button */}
          <button
            type="submit"
            style={{
              all: "unset",
              boxSizing: "border-box",
              display: "block",
              width: "100%",
              textAlign: "center",
              background: "var(--site-header-gradient)",
              color: "#fff",
              padding: "10px 14px",
              borderRadius: "6px",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "bold",
              cursor: "pointer",
              marginBottom: "4px",
              border: "none",
              boxShadow: "none",
            }}
          >
            Login
          </button>

          {/* Login with Demo ID button */}
          <button
            type="button"
            onClick={() =>
              loginUser({ username: "demo", password: "demo123", uniqueId: Math.random() * 10000 })
            }
            style={{
              all: "unset",
              boxSizing: "border-box",
              display: "block",
              width: "100%",
              textAlign: "center",
              background: "var(--site-header-gradient)",
              color: "#fff",
              padding: "10px 14px",
              borderRadius: "6px",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "bold",
              cursor: "pointer",
              border: "none",
              boxShadow: "none",
            }}
          >
            Login with Demo ID
          </button>

          {/* Error message */}
          {isLoged === "failed" && (
            <p
              style={{
                color: "#ff6b6b",
                textAlign: "center",
                marginTop: "12px",
                fontSize: "13px",
              }}
            >
              Login name or password is invalid! Please try again.
            </p>
          )}
        </form>

        {/* Static content modals */}
        {content && (
          <div className="frame-wrap">
            <div className="news-wrap news-wrap-frame">
              {slug === "about" && <Aboutus />}
              {slug === "term" && <GeneralTerms />}
              {slug === "kyc" && <Kyc />}
              {slug === "privacy" && <PrivacyPolicy />}
              {slug === "rules" && <RulesRegulation />}
              {slug === "responsible" && <ResponsibleGaming />}
              <footer>
                <Link
                  to="#"
                  className="btn-send"
                  onClick={() => {
                    handleContentToggle();
                    setSlug("");
                  }}
                >
                  CLOSE
                </Link>
              </footer>
            </div>
          </div>
        )}
      </div>

      {loading && <LoadingPage />}
    </>
  );
}

export default Login;
